import { Checkbox, FormControlLabel } from '@mui/material';
import { CreateOrderCheckboxProps } from './CreateOrderCheckbox.types';

export const CreateOrderCheckbox = ({ hasOrderOptions, disabled, checked, onChange }: CreateOrderCheckboxProps) => {
  if (!hasOrderOptions) {
    return <></>;
  }
  return (
    <div className="upload-order-container">
      <FormControlLabel
        control={<Checkbox checked={checked} disabled={disabled} onChange={onChange} />}
        label={<span className="upload-order-label">Сформувати розпорядження</span>}
      />
    </div>
  );
};
